import Vue from 'vue'
import Router from 'vue-router'

import Index from '../view/index/Index.vue'
// const Index = resolve => require(['@/view/index/Index.vue'], resolve);
import ReLogin from '../components/Relogin.vue'
import Detail from '../view/detail/Detail.vue'
import Refresh from '../components/Refresh'

import routerUser from './router-user'
import routerStudy from './router-study'
import routerFaq from './router-faq'
import routerToolkit from './router-toolkit'
import routerExam from './router-exam'
import routerInclude from './router-include'
import routerKeyword from './router-keyword'
import routerMember from './router-member'
import routerWelfare from './router-welfare'

Vue.use(Router);

let routes = [
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: '/index',
        name: 'index',
        component: Index,
        meta: {
            title: '【旋涡营销】一款智能网站营销力检测工具',
            keywords: '旋涡营销,网站诊断工具,营销力检测工具,网站检测,网站营销力诊断',
            description: '旋涡营销是一款网站营销力智能检测诊断工具,致力于为企业提供网站在线诊断、在线问答、在线学习和落地执行管家服务，让企业网络营销更精准，帮助企业从0到1完成互联网+。'
        }
    },
    {
        path: '/relogin',
        name: 'relogin',
        component: ReLogin,
        meta: {
            title: '【旋涡营销】登录'
        }
    },
    {
        path: '/detail/:token',
        name: 'detail',
        component: Detail,
        meta: {
            title: '【旋涡营销】网站诊断详细'
        }
    },
    {
        path: '/refresh',
        name: 'refresh',
        component: Refresh
    }
];

routes = routes.concat(routerUser, routerFaq, routerStudy, routerToolkit, routerExam,routerInclude,routerKeyword,routerMember,routerWelfare);

const router = new Router({
    routes
});

//路由配置
router.afterEach((to) => {
    document.title = to.meta.title || to.name;
    // 替换meta
    document.querySelector('[name=keywords]').content = to.matched[0].meta.keywords || '旋涡营销,网站诊断工具,营销力检测工具,网站检测,网站营销力诊断';
    document.querySelector('[name=description]').content = to.matched[0].meta.description || '旋涡营销是一款网站营销力智能检测诊断工具,致力于为企业提供网站在线诊断、在线问答、在线学习和落地执行管家服务，让企业网络营销更精准，帮助企业从0到1完成互联网+。';
    // 百度统计
    window._hmt && window._hmt.push(['_trackPageview', '/#' + to.path]);
});

export default router



// WEBPACK FOOTER //
// ./app/router/index.js